import React from 'react';
import { isEmailJSConfigured } from '../utils/emailService';

const EmailDebug = () => {
  return null;
  // Only show in development
  if (process.env.NODE_ENV !== 'development') {
    return null;
  }

  const checkConfig = () => {
    const serviceId = process.env.REACT_APP_EMAILJS_SERVICE_ID;
    const templateId = process.env.REACT_APP_EMAILJS_TEMPLATE_ID;
    const publicKey = process.env.REACT_APP_EMAILJS_PUBLIC_KEY;
    
    console.log('Raw Environment Variables:', {
      REACT_APP_EMAILJS_SERVICE_ID: serviceId ? `${serviceId.substring(0, 8)}...` : 'NOT SET',
      REACT_APP_EMAILJS_TEMPLATE_ID: templateId ? `${templateId.substring(0, 8)}...` : 'NOT SET',
      REACT_APP_EMAILJS_PUBLIC_KEY: publicKey ? `${publicKey.substring(0, 8)}...` : 'NOT SET'
    });
    
    isEmailJSConfigured();
  };

  return (
    <div className="fixed bottom-4 left-4 bg-yellow-100 border border-yellow-300 rounded-lg p-3 text-sm z-50">
      <div className="font-medium text-yellow-800 mb-2">
        🔧 Development Mode - EmailJS Debug
      </div>
      <button
        onClick={checkConfig}
        className="bg-yellow-200 hover:bg-yellow-300 px-3 py-1 rounded text-yellow-800 text-xs"
      >
        Check Email Config
      </button>
      <div className="text-xs text-yellow-700 mt-2">
        Check browser console for details
      </div>
    </div>
  );
};

export default EmailDebug;